import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Table, Thead, Tbody, Tr, Th, Td } from '@chakra-ui/react';
import moment from 'moment';
import 'moment/locale/fi';
import 'moment/locale/sv';

const mapName = (members, username) => {
  const member = members.find((m) => m.email === username);
  return member ? member.name : username;
};

const SessionList = ({ sessions, members }) => {
  const { t, i18n } = useTranslation();

  const locale = (i18n.language || 'fi').substr(0, 2);

  return (
    <Table mt="4" position="relative" sx={{ Th: { px: 2 }, Td: { px: 2, verticalAlign: 'top' } }}>
      <Thead>
        <Tr>
          <Th>{t('organization.session.date')}</Th>
          <Th>{t('organization.session.status')}</Th>
          <Th>{t('organization.session.interpreter')}</Th>
          <Th>{t('organization.session.duration')}</Th>
          <Th width="50%">{t('organization.session.title')}</Th>
        </Tr>
      </Thead>
      <Tbody>
        {sessions.length === 0 && (
          <Tr>
            <Td>{t('organization.noSessions')}</Td>
          </Tr>
        )}
        {(sessions || []).map((session) => {
          return (
            <Tr
              key={session._id}
              sx={{
                ':hover': { bg: '#eee' },
              }}
            >
              <Td>{moment(session.dateTime).format('D.M.YYYY')}</Td>
              <Td>{t('status.' + session.status)}</Td>
              <Td>{mapName(members, session.username)}</Td>
              <Td>
                {moment
                  .duration(
                    -(session.actualDurationSeconds || session.estimatedDurationSeconds),
                    'seconds'
                  )
                  .locale(locale)
                  .humanize(false)}
              </Td>
              <Td>{session.title}</Td>
            </Tr>
          );
        })}
      </Tbody>
    </Table>
  );
};

SessionList.propTypes = {
  sessions: PropTypes.arrayOf(PropTypes.object),
  members: PropTypes.arrayOf(PropTypes.object),
};

export default SessionList;
